import {
  referenceIdNumberRule,
  positiveNumberRule,
  percentageRule,
  allocationPreferenceRule,
} from '@/lib/validation';

// Format rules for <ContractForm>, keyed by field name; `required` lives on each <Field>.
export const contractValidation = {
  allocationPreference: allocationPreferenceRule,
  idNumber: referenceIdNumberRule,
  contractedQuantity: positiveNumberRule,
  density: positiveNumberRule,
  ghgEmissions: positiveNumberRule,
  // A percentage, so it is capped at 100 as well as floored at 0.
  ghgEmissionSavings: percentageRule,
};
